import { Helmet } from "react-helmet-async";

// Per-tab SEO for the /app pages: title, description, canonical, OG tags,
// and (for generator tabs) SoftwareApplication schema with the price — the
// same schema shape the state landing pages use.
export default function AppSeo({ title, description, path, price, appName }) {
  const url = `https://mintslip.com${path}`;
  const schema = price
    ? {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": appName || title,
        "description": description,
        "url": url,
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web",
        "offers": { "@type": "Offer", "price": String(price), "priceCurrency": "USD" },
      }
    : null;

  return (
    <Helmet>
      <title>{`${title} | MintSlip`}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={`${title} | MintSlip`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://mintslip.com/og-image.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title} | MintSlip`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://mintslip.com/og-image.png" />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
